<template>
  <div class="grid-standard gap-x-6 md:py-6">
    <SkeletonAnimatedPlaceholder
      height="22px"
      width="100%"
      border-radius="8px"
      class="col-span-full hidden md:block"
    />
    <SkeletonAnimatedPlaceholder
      height="40px"
      width="100%"
      border-radius="8px"
      class="col-span-full mb-8 mt-4"
    />
    <div class="col-span-full grid grid-cols-4 gap-6 md:grid-cols-12">
      <SkeletonAnimatedPlaceholder
        v-for="(item, index) in 8"
        :key="`card-${index}`"
        height="400px"
        width="100%"
        border-radius="8px"
        class="col-span-full md:col-span-3"
      />
    </div>
  </div>
</template>
